import { useState } from "react";
import { faqs, site } from "@/mocks/hotlist";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-400 font-medium">
              <span className="w-6 h-px bg-primary-500" />
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              关于榜单，你可能想问
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们把读者问得最多的几个问题整理在这里。如果还有疑问，可以在下方留言，或直接发邮件给我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-400 whitespace-nowrap cursor-pointer hover:text-primary-300 transition-colors"
            >
              还有其他问题？
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
              {faqs.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div key={item.q} className="border-b border-background-200/60 last:border-b-0">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? -1 : index)}
                        aria-expanded={open}
                        className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-6 py-4 md:py-5 cursor-pointer hover:bg-background-200/40 transition-colors"
                      >
                        <span className="font-medium text-sm md:text-base text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-200/70 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    {open && (
                      <div className="px-4 md:px-6 pb-5 -mt-1 animate-fade-in">
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <p className="mt-4 text-xs text-foreground-500">{site.updatedAt} · 榜单规则如有调整会在此说明</p>
          </div>
        </div>
      </div>
    </section>
  );
}